<div class="h-30"></div>
<form>
  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Organization Name</mat-label>
      <input matInput class="form-control-textbox" [(ngModel)]="org.organizationName" name="orgname" />
    </mat-form-field>
    @if (isSubmitted && (org.organizationName === null || org.organizationName === undefined || org.organizationName === '')) {
      <mat-error class="validation-error">Organization Name is required</mat-error>
    }
  </div>
  <div class="mb-10"></div>


  <div class="form-fields">
    <mat-form-field appearance="outline" floatLabel="always">
      <mat-label>Province</mat-label>
      <mat-select placeholder="Select Type" name="courselanguage" [(ngModel)]="org.provinceId">
        @for (p of province; track p) {
          <mat-option [value]="p.id">
            {{p.provinceName}}
          </mat-option>
        }
      </mat-select>
    </mat-form-field>
    @if (isSubmitted && org.provinceId ==0) {
      <mat-error class="validation-error">Province is required</mat-error>
    }
  </div>
  <div class="mb-10"></div>

  <div>
    Status
    <div class="toggle">
      <div class="switch-div">
        <input type="radio" name="sizeBy" [value]="true" id="active" class="active" [(ngModel)]="org.isActive" />
        <label for="active">Active</label>
      </div>
      <div class="switch-div">
        <input type="radio" name="sizeBy" [value]="false" id="inactive" class="inactive" [(ngModel)]="org.isActive"/>
        <label for="inactive">Inactive</label>
      </div>
    </div>
  </div>


  <div class="mb-10"></div>
</form>
<div class="mb-10"></div>
